var map = {
	"./best_sunset.jpg": 125,
	"./brandon.jpg": 670,
	"./cat.jpg": 38,
	"./channel_islands.jpg": 88,
	"./double.jpg": 511,
	"./german_field.jpg": 151,
	"./grindelwald.jpg": 15,
	"./lucerne.jpg": 500,
	"./lucernesunrise.jpg": 691,
	"./luxemborg_gardens.jpg": 964,
	"./mrecho.jpg": 886,
	"./owl_butterfly.jpg": 112,
	"./peace.jpg": 532,
	"./sunset_cliffs.jpg": 70
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 675;